import React from 'react';
import Form from 'react-bootstrap/Form';

// A2LToggle component for toggling the display of new A2L products.
// This is used for HFC Refrigerant to show A2L models when the toggle is enabled
const A2LToggle = ({ a2lValue, onToggle }) => {
  return (
      <Form.Group controlId="td">
        <Form.Label>Show New A2L Products</Form.Label>
        <div className="switch-container">
          <label className="switch">
            <input type="checkbox" checked={a2lValue} onChange={onToggle} />
            <span className="slider"></span>
          </label>
        </div>
      </Form.Group>
  );
};

export default A2LToggle;
